<template>
  <!-- loader -->
  <div class="loader">
    <v-progress-circular
        indeterminate
        :color="this.$spinner_color"
        v-if="this.loader == true"
    ></v-progress-circular>
  </div>
</template>

<script>

export default {
  name: "loaderComponent",
  props: {
    loader: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return{

    }
  },
  mounted() {

  },
  methods: {

  },
};
</script>